/**
 * A grade de alocacao: pessoa x semana.
 *
 * Mostra CAPACIDADE, PLANEJADO, ATRIBUIDO e REALIZADO lado a lado. Nenhum
 * deles sozinho responde "esta sobrecarregada?" -- planejado alto com
 * atribuido baixo e um plano que nao virou trabalho; atribuido alto com
 * apontado baixo e trabalho que nao esta sendo feito, ou que nao esta sendo
 * apontado. Os quatro juntos sao uma conversa.
 */
export const nav = {
    permissao: 'deck.alocacao:ver',
    section: 'Gestao',
    title: 'Alocacao',
    icon: 'event_available',
    route: '/alocacao',
    sequence: 20,
};

export default [
    {
        path: '/alocacao',
        name: 'alocacao',
        component: () => import('./pages/AlocacaoPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.alocacao:ver' },
    },
];
